import months from '../../utils/months';

const yearRegex = /^\d{4}$/;

const stringArrayRegex = (strings) =>
  new RegExp(`^(${strings.join('|')})$/`, 'gmi');

const fullMonthNameRegex = stringArrayRegex(
  months.map((monthObj) => monthObj.monthName)
);

const shortMonthNameRegex = stringArrayRegex(
  months.map((monthObj) => monthObj.shortName)
);

export const isYearPartValid = (campaignName) => {
  const yearPart = campaignName.split('_')[0];
  return yearRegex.test(yearPart);
};

export const isMonthPartValid = (campaignName) => {
  const monthPart = campaignName.split('_')[1] || '';
  return (
    fullMonthNameRegex.test(monthPart) || shortMonthNameRegex.test(monthPart)
  );
};

export const getMonthFromCampaignTime = (campaign) => {
  const startTime = campaign.start_time;
  const monthInt = new Date(startTime).getMonth() + 1;
  const monthObj = months.find((obj) => obj.monthNumber === monthInt);
  if (!monthObj) return null;
  return monthObj.shortName;
};

export const getMonthFromCampaign = (campaign) => {
  const campaignName = campaign.name;

  const campaignNameParts = campaignName.split('_');
  if (isMonthPartValid(campaignName)) {
    return campaignNameParts[1];
  }

  const shortMonthMatch = campaignName.match(shortMonthNameRegex);
  if (shortMonthMatch) {
    const monthObj = months.find(
      (obj) => obj.shortName.toLowerCase() === shortMonthMatch[0].toLowerCase()
    );
    return monthObj.shortName;
  }

  return getMonthFromCampaignTime(campaign);
};

export const getYearFromCampaignTime = (campaign) => {
  const startTime = campaign.start_time;
  const createdTime = campaign.create_time;
  const year = new Date(
    startTime.toLowerCase() !== 'multiple' ? startTime : createdTime
  ).getFullYear();

  return year;
};

export const getYearFromCampaign = (campaign) => {
  const campaignName = campaign.name;

  const campaignNameParts = campaignName.split('_');
  if (isYearPartValid(campaignName)) {
    return campaignNameParts[0];
  }
  const yearMatch = campaignName.match(/\d{4}/g);
  if (yearMatch) return yearMatch[0];

  return getYearFromCampaignTime(campaign);
};

export const replaceYearAndMonth = (str, newDates) => {
  // Possible TODO: replace all instances of year with newYear
  const currMonthReg = new RegExp(`${newDates.month}`, 'gi');
  const newString = str
    .replace(newDates.year, newDates.newYear)
    .replace(currMonthReg, newDates.newMonth)
    .replace(' - Copy', '');
  return newString;
};

export const isNullOrUndefined = (value) =>
  value === undefined || value === null;



// WEBPACK FOOTER //
// ./src/screens/Flipper/utils.js